/**
 * Textos de les millores de Compres (`ca`): ajunta els fitxers de cada tall. Cablejat a `ca.ts` amb un sol
 * `...compresCa`; així cada tall edita només el seu fitxer.
 */

import { estatsCa } from './estats.ca.js';
import { filtresCa } from './filtres.ca.js';
import { devolucionsCa } from './devolucions.ca.js';

export const compresCa = {
  ...estatsCa,
  ...filtresCa,
  ...devolucionsCa,
} as const;
